function TopicPicker({ subject, topics, color, getTopicAccuracy, isPremium, questionsLeft, onSelect, onUpgrade, t, tTopic }) {
  return (
    <div className="topic-picker">
      <p className="subtitle">{t('pickTopic')}</p>

      {!isPremium && (
        <div className="freemium-bar">
          <span>{questionsLeft === 0 ? t('dailyLimitReached') : t('questionsLeftToday', questionsLeft)}</span>
          <button className="upgrade-link" onClick={onUpgrade}>{t('goPremiumBtn')}</button>
        </div>
      )}

      <div className="topic-grid">
        {topics.map(topic => {
          const acc = getTopicAccuracy(topic);
          return (
            <button
              key={topic}
              className="topic-row"
              style={{ borderLeftColor: color }}
              onClick={() => questionsLeft === 0 && !isPremium ? onUpgrade() : onSelect(topic)}
            >
              <span className="topic-name">{tTopic(topic)}</span>
              {acc !== null
                ? <span className="topic-acc" style={{ color }}>{acc}%</span>
                : <span className="topic-acc-empty">{t('notStarted')}</span>
              }
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default TopicPicker;
